import {AxiosInstance, AxiosRequestConfig} from "axios";
import {MemberStore} from "@/store/modules/MemberStore";

export const memberHeaderInterceptor = (instance: AxiosInstance) => instance.interceptors.request.use(
    function (config: AxiosRequestConfig) {
      const token = (MemberStore as any).state.token;
      if (token) {
        config.headers['x-user-token'] = token;
      }

      const phoneNumber = (MemberStore as any).state.phoneNumber;
      if (phoneNumber) {
        config.headers['x-user-tel-no'] = phoneNumber;
      }
      return config;
    },
);